module.exports = __webpack_public_path__ + "static/media/ic_normalized_series.e6bbdc20.svg";